import { Link } from "react-router-dom";
import { Mail, Phone, Globe, MapPin } from "lucide-react";
import { Logo } from "./Logo";

export const Footer = () => (
  <footer className="relative bg-[#050A15] border-t border-[#d4a840]/20 mt-24" data-testid="site-footer">
    <div className="absolute inset-x-0 -top-px kb-hairline" />
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
      <div className="md:col-span-2">
        <Logo />
        <p className="mt-6 text-white/70 max-w-md leading-relaxed">
          Your trusted partner in every step of your business journey. Simplifying compliance,
          empowering businesses across India.
        </p>
        <div className="mt-6 kb-label">Compliance Today. Success Tomorrow.</div>
      </div>

      <div>
        <div className="kb-label mb-4">Explore</div>
        <ul className="space-y-3 text-white/80">
          <li><Link to="/" className="hover:text-[#d4a840] transition-colors" data-testid="footer-link-home">Home</Link></li>
          <li><Link to="/about" className="hover:text-[#d4a840] transition-colors" data-testid="footer-link-about">About</Link></li>
          <li><Link to="/services" className="hover:text-[#d4a840] transition-colors" data-testid="footer-link-services">Services</Link></li>
          <li><Link to="/process" className="hover:text-[#d4a840] transition-colors" data-testid="footer-link-process">Process</Link></li>
          <li><Link to="/contact" className="hover:text-[#d4a840] transition-colors" data-testid="footer-link-contact">Contact</Link></li>
        </ul>
      </div>

      <div>
        <div className="kb-label mb-4">Reach Us</div>
        <ul className="space-y-3 text-white/80 text-sm">
          <li className="flex items-center gap-3"><Globe size={16} className="text-[#d4a840]" /> www.kaveribiz.com</li>
          <li className="flex items-center gap-3"><Mail size={16} className="text-[#d4a840]" /> info@kaveribiz.com</li>
          <li className="flex items-center gap-3"><Phone size={16} className="text-[#d4a840]" /> +91 88671 92221</li>
          <li className="flex items-start gap-3"><MapPin size={16} className="text-[#d4a840] mt-1" /> India — serving businesses nationwide</li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-white/50">
        <div>© {new Date().getFullYear()} KaveriBiz Corporate Services LLP. All rights reserved.</div>
        <div className="tracking-[0.25em] uppercase text-[#d4a840]/70">Simplifying Compliance · Empowering Businesses</div>
      </div>
    </div>
    <div className="border-t border-white/5 bg-[#03060d]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-4 flex items-center justify-center gap-2.5 text-xs text-white/50" data-testid="footer-powered-by">
        <span className="tracking-wide">Powered by</span>
        <span className="inline-flex items-center gap-2 rounded-full border border-white bg-white pl-1 pr-3 py-1">
          <img src="/ems_logo.png" alt="Echomatrix Solutions logo" className="h-5 w-5 rounded-full object-contain" />
          <span className="font-semibold text-[#0a0e2a]">Echomatrix Solutions</span>
        </span>
      </div>
    </div>
  </footer>
);
